<template>
    <v-form ref="service-form" v-model="formValid">
        <v-text-field
                v-model="code"
                label="Code"
                :rules="codeRules"
                required
                :errorMessages="codeErrorMessages"
                @input="handleFieldInput($event, 'code')"></v-text-field>
        <v-text-field
                v-model="title"
                label="Title"
                :rules="titleRules"
                required
                :errorMessages="titleErrorMessages"
                @input="handleFieldInput($event, 'title')"></v-text-field>
        <v-text-field
                v-model="price"
                label="Price"
                :rules="priceRules"
                required
                :errorMessages="priceErrorMessages"
                @input="handleFieldInput($event, 'price')"></v-text-field>
    </v-form>
</template>

<script>
    import {isNumeric} from '../../../helpers/numbers'

    import {mapGetters, mapActions, mapState} from 'vuex'

    export default {
        name: 'ServiceForm',
        props: {
          service: Object,
          context: String,
        },
        data() {
            return {
                valid: false,
                titleRules: [
                    v => !!v || 'Enter service title',
                    v => (v && v.length <= 1000) || 'The length of the name should be no more than 1000 characters'
                ],
                codeRules: [
                    v => !!v || 'Enter service code',
                    v => (v && v.length <= 255) || 'Service code must be no more than 255 characters'
                ],
                priceRules: [
                    v => !!v || 'Enter service base price',
                    function (v) {
                        return isNumeric(v) || 'Value must be numeric'
                    },
                    function (v) {
                        return isNumeric(v) && parseFloat(v) > 0.0 || "Value must be positive"
                    }
                ],
            }
        },
        computed: {
            ...mapGetters('services', {
                serviceFormValidationErrorsByField: 'serviceFormValidationErrorsByField'
            }),
            codeErrorMessages() {
                return this.serviceFormValidationErrorsByField(this.context, 'code')
            },
            titleErrorMessages() {
                return this.serviceFormValidationErrorsByField(this.context, 'title')
            },
            priceErrorMessages() {
                return this.serviceFormValidationErrorsByField(this.context, 'price')
            },
            formValid: {
                get () {
                    return this.valid
                },
                set (value) {
                    this.$emit('validation-changed', {context: this.context, value: value})
                }
            },
            code: {
                get() {
                    return this.service.code
                },
                set(value) {
                    this.changeServiceFormField({
                        context: this.context,
                        name: 'code',
                        value: value
                    })
                }
            },
            title: {
                get() {
                    return this.service.title
                },
                set(value) {
                    this.changeServiceFormField({
                        context: this.context,
                        name: 'title',
                        value: value
                    })
                }
            },
            price: {
                get() {
                    return this.service.price
                },
                set(value) {
                    this.changeServiceFormField({
                        context: this.context,
                        name: 'price',
                        value: value
                    })
                }
            }
        },
        methods: {
            ...mapActions('services', {
                changeServiceFormField: 'changeServiceFormField',
                resetServiceFormValidationErrorsByField: 'resetServiceFormValidationErrorsByField'

            }),
            handleFieldInput (e, fieldName) {
                const errorMessages = this.serviceFormValidationErrorsByField(this.context, fieldName)

                if (errorMessages.length === 0)  {
                    return
                }

                this.resetServiceFormValidationErrorsByField({
                    context: this.context,
                    fieldName: fieldName
                })
            }
        }
    }
</script>

<style scoped>

</style>